import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import axios from 'axios';
import ManageTaskGrid from './ManageTaskGrid';
import { useLocation } from 'react-router-dom';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getStorageValues } from '../../shared/CommonFunctions';
import { logAuditEvent } from '../../utils/auditLogger';

function ManageTaskMain(props) {
  const [getTaskList, setTaskList] = useState([]);
  const location = useLocation();
  const defaultTaskId = location.state?.DefaultTaskId;
  const defaultTaskKey = location.state?.DefaultTaskKey;
  const defaultStatusFilter = location.state?.DefaultStatusFilter;
  const defaultCompanyTypeFilter = location.state?.DefaultCompanyTypeFilter;
  const showFollowupTab = location.state?.showFollowupTab || false;
  const moduleName = props.Module || 'Manage Task';
  useEffect(() => {
    fetchTask();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Manage Task');
  }, [moduleName]);

  const fetchTask = async () => {
     try {
       let taskDetails = {
         UserId: getStorageValues('userId'),
         ByUser: 0
       };
       const response = await axios.get(getApiBaseUrl() + "/tasklist", { params: taskDetails });
       if (response.status === 200) {
         setTaskList(response.data.data[0]);
       }
     } catch (error) {
       console.log(error);
     }
   };
  const handleRefresh = () => {
    logAuditEvent(moduleName, 'Refresh Click', 'Refreshed task list');
    fetchTask();
  };

  return (
    <>
      <PageHeader
        displayText={""}
        displayModule={props.Module}
        onRefresh={handleRefresh}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={true}
        showAddButton={false}
      />
      <ManageTaskGrid 
        TaskData={getTaskList} 
        fetchTask={fetchTask}
        DefaultTaskId={defaultTaskId}
        DefaultTaskKey={defaultTaskKey}
        DefaultStatusFilter={defaultStatusFilter}
        DefaultCompanyTypeFilter={defaultCompanyTypeFilter}
        DefaultShowFollowupTab={showFollowupTab}
      />
    </>
  )
}

export default ManageTaskMain